import FirmDetailsView from "@/components/features/settings/firm/FirmDetailsView";
import { Text } from "@/components/ui";

export default function FirmDetailsCard() {
  return (
    <div className="w-full">
      <div className="mb-8 gap-y-1">
        <Text variant="title">Firm details</Text>
      </div>
      <FirmDetailsView />
    </div>
  );
}
